import React, { useState, useEffect, useRef } from 'react';
import '../estilos/Fonts.css';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



const PortadaEmpatica = () => {
  const fondo = require('../recursos/consultoria/Fondo-1.png');
  const imgFondoEquipo = require('../recursos/consultoria/Team.png'); // Imagen del fondo (grupo)
  const imgPersona = require('../recursos/consultoria/Empresaria.png');    // Imagen superpuesta (mujer)


  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedForm, setSelectedForm] = useState("COLABORADOR");

  // Refs para las secciones
  const culturaRef = useRef(null);
  const alianzasRef = useRef(null);
  const we360Ref = useRef(null);
  const footerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToSection = (sectionRef) => {
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    // Cerrar menú móvil después de hacer clic
    if (isMobile) {
      setMenuOpen(false);
    }
  };

  const handleMenuClick = (section) => {
    switch (section) {
      case 'QUIENES_SOMOS':
        scrollToSection(culturaRef);
        break;
      case 'ALIANZAS':
        scrollToSection(alianzasRef);
        break;
      case 'WE360':
        scrollToSection(we360Ref);
        break;
      case 'CONTACTO':
        scrollToSection(footerRef);
        break;
      default:
        break;
    }
  };

  const servicios = [
    {
      img: require('../recursos/consultoria/Estrategia-Comercial.png'),
      titulo: 'ESTRATEGIA COMERCIAL',
      modal: {
        titulo: "Estrategia comercial",
        contenido: (
          <>
            <p><b>Dolor:</b> Ventas estancadas, mensajes que no convierten, canal moderno sin tracción.</p>
            <p><b>Incluye:</b> Propuesta de valor y segmentación; playbook de venta; KAM; pricing/promos; calendario comercial; CRM y funnel.</p>
            <p><b>Entregables:</b> Playbook, scripts y objeciones, plan de canales, pipeline objetivo.</p>
            <p><b>KPIs:</b> Velocidad de pipeline, tasa de conversión por etapa, ticket/cliente, mix de canales.</p>
          </>
        )
      }
    },
    {
      img: require('../recursos/consultoria/Legal.png'),
      titulo: 'LEGAL (BLINDAJE ORGANIZACIONAL)',
      modal: {
        titulo: "Legal (Blindaje Organizacional)",
        contenido: (
          <>
            <p><b>Dolor:</b> Riesgos laborales/contractuales, reglamentos obsoletos, sanciones por incumplimientos.</p>
            <p><b>Incluye:</b> Auditoría legal-laboral; actualización de <span
                    style={{
                      fontWeight: "bold",
                      fontFamily: 'Montserrat-Regular',
                    }}>
                   Reglamento Interior de Trabajo; 
                  </span>{" "}contratos y anexos; políticas (asistencia, datos, seguridad e higiene); alineación con DO y RH.</p>
            <p><b>Entregables:</b> reglamento actualizado, pack de contratos/formatos, matriz de riesgos y acciones.</p>
            <p><b>KPIs:</b> % documentos actualizados; # incidencias legales; cumplimiento de políticas (&gt;95%).</p>
          </>
        )
      }
    },
    {
      img: require('../recursos/consultoria/Atraccion-de-talento.png'),
      titulo: 'ATRACCIÓN DE TALENTO',
      modal: {
        titulo: "Atracción de talento",
        contenido: (
          <>
            <p><b>Dolor:</b> Vacantes mal definidas, altas fallidas, rotación.</p>
            <p><b>Incluye:</b> Descriptivos de puestos y tableros de evaluación de desempeño, metodologías para reducir el riesgo de una mala contratación con filtros y pruebas. Desarrollo de planes de onboarding.</p>
            <p><b>Entregables:</b>Evaluaciones de desempeño por puesto, procesos claros de reclutamiento, ternas de candidatos finales, planes de onboarding 30 – 60 – 90 – 180 y 365 días.</p>
            <p><b>KPIs:</b> Tasa de contratación de jugadores clave y tasa de retención de jugadores clave.</p>
          </>
        )
      }
    },
    {
      img: require('../recursos/consultoria/Sistema-directivo.png'),
      titulo: 'SISTEMA DIRECTIVO',
      modal: {
        titulo: "Sistema directivo",
        contenido: (
          <>
            <p><b>Dolor:</b> Atrapado en tu empresa, prioridades difusas, juntas improductivas, KPIs que no mueven la aguja, incertidumbre, miedo e incapacidad de delegar.</p>
            <p><b>Incluye:</b> Sistema de posicionamiento empresarial con base en las mejores prácticas, ausencia de reuniones productivas, tableros eficientes, claridad en el paso a paso y gestión de riesgos.</p>
            <p><b>Entregables:</b> Sistema de posicionamiento empresarial, tableros ejecutivos, claridad, tranquilidad y enfoque.</p>
            <p><b>KPIs:</b> Cumplimiento de prioridades (menor al 80%), puntualidad de métricas (menor al 95%), porcentaje de metas trimestrales.</p>
          </>
        )
      }
    },
    {
      img: require('../recursos/consultoria/Desarrollo-Organizacional.png'),
      titulo: 'DESARROLLO ORGANIZACIONAL',
      modal: {
        titulo: "Desarrollo organizacional",
        contenido: (
          <>
            <p><b>Dolor:</b> Empresas estancadas, cicladas, con cambios de timón constante, cuellos de botella en líderes y alta dirección, culturas no operativas, roles confusos y líderes sin herramientas.</p>
            <p><b>Incluye:</b> Filosofía empresarial sólida, arquitectura organizacional clara, organigramas, descriptivos de puestos, planes de liderazgo, planes de vida y carrera, herramientas para la mejora continua del clima laboral.</p>
            <p><b>Entregables:</b> Desarrollo organizacional, más líderes para tu empresa alineados en cultura, con tableros de evaluación claros, planes de liderazgo definidos y planes de comunicación interna.</p>
            <p><b>KPIs:</b> Satisfacción interna y externa, porcentaje de cumplimiento individual, programas de bienestar y porcentaje de personal que evoluciona dentro de la organización.</p>
          </>
        )
      }
    },
    {
      img: require('../recursos/consultoria/Contabilidad.png'),
      titulo: 'CONTABILIDAD',
      modal: {
        titulo: "Contabilidad",
        contenido: (
          <>
            <p><b>Dolor:</b> Sin claridad, falta de flujo de efectivo (oxigeno), costeos, toma de deciciones desde la emoción, desconocimiento del estado de salud financiera.</p>
            <p><b>Incluye:</b> Estados dinancieros, capacitación y alineación de los elementos claves a la información financiera.</p>
            <p><b>Entregables:</b> Bases de datos sanas que alimentan a balances generales. balance general, estados financieron, disminución de la carga fiscal, indiflujo de efectivo y presupuestos.</p>
            <p><b>KPIs:</b> Indicadores en la eficiencia en los pagos de impuestos, flujos de efectivo, cumplimiento de presupuesto, disminución de pagos tardios, recargos y multas.</p>
          </>
        )
      }
    },
    {
      img: require('../recursos/consultoria/DiseñoMKT.png'),
      titulo: 'DISEÑO + MARKETING',
      modal: {
        titulo: "Diseño + marketing",
        contenido: (
          <>
            <p><b>Dolor:</b> marca sin diferenciación, campañas sin ROI, redes sin estrategia.</p>
            <p><b>Incluye:</b> identidad y tono; calendario editorial; performance básico; landing/web orientada a conversión; packaging y piezas clave.</p>
            <p><b>Entregables:</b> brand kit, playbook de contenido, landing/UX de captación, piezas para campañas.</p>
            <p><b>KPIs:</b> leads calificados, CAC, CTR/CPA, tasa de conversión, revenue atribuible.</p>
          </>
        )
      }
    },
    {
      img: require('../recursos/consultoria/Relaciones_Sanas.png'),
      titulo: '1 MILLÓN DE RELACIONES LABORALES SANAS',
      modal: {
        titulo: "1 millón de relaciones laborales sanas",
        contenido: (
          <>
            <p><b>Dolor:</b> fricción interna, comunicación rota, riesgo psicosocial.</p>
            <p><b>Incluye:</b> diagnóstico de clima; protocolos y campañas internas; capacitación en feedback y liderazgo; wellness 360°.</p>
            <p><b>Entregables:</b> plan semestral de endomarketing, toolkit de feedback, calendario de bienestar.</p>
            <p><b>KPIs:</b> eNPS, ausentismo, rotación voluntaria, reportes resueltos.</p>
          </>
        )
      }
    },
    {
      img: require('../recursos/consultoria/We360.png'),
      titulo: 'WE360°',
      modal: {
        titulo: "WE360°",
        contenido: (
          <>
            <p><b>Dolor:</b> seguimiento débil y prioridades que se diluyen.</p>
            <p><b>Incluye:</b> tablero de ejecución semanal (Victoria, Prioridades, Necesito ayuda, Mi semana sería exitosa si…), recordatorios, vistas por área.</p>
            <p><b>Entregables:</b> tablero activo por equipo y ritual semanal.</p>
            <p><b>KPIs:</b> cumplimiento semanal, bloqueos resueltos, % prioridades en verde.</p>
          </>
        )
      }
    },
  ];

  const navItems = [
    { label: '¿QUIÉNES SOMOS?', id: 'QUIENES_SOMOS' },
    { label: 'ALIANZAS', id: 'ALIANZAS' },
    { label: 'CONTACTO', id: 'CONTACTO' },
    { label: 'WE360°', id: 'WE360' }
  ];

  const culturaSlides = [
    {
      titulo: "SOMOS LEALES A NUESTRA CULTURA Y FILOSOFÍA",
      texto: "Somos fieles a nuestra esencia, pero nunca estáticos. Evolucionamos con el tiempo sin perder lo que nos define. Nuestra filosofía guía nuestras acciones, decisiones y la forma en que impactamos positivamente a cada cliente. Evolucionamos a México un empresario a la vez."
    },
    {
      titulo: "CRECEMOS JUNTO A NUESTROS CLIENTES",
      texto: "Cada proyecto es una oportunidad para crecer en conjunto. Nuestra meta es impulsar a cada aliado a lograr sus objetivos estratégicos con innovación y confianza."
    }
  ];
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const openModal = (data) => {
    setModalData(data);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalData(null);
  };

  // Configuración del carrusel
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: dots => (
      <div style={{ marginTop: "20px" }}>
        <ul style={{ margin: "0px" }}>{dots}</ul>
      </div>
    ),
    customPaging: () => (
      <div
        style={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: "#1f4aa8"
        }}
      ></div>
    )
  };

  //  estilo reutilizable para inputs
  const inputStyle = {
    width: "100%",
    padding: "12px",
    marginBottom: "15px",
    border: "none",
    borderBottom: "2px solid #00ffc8",
    background: "transparent",
    color: "#fff",
    fontSize: 16,
    outline: "none"
  };

  // contenido dinámico de cada formulario
  const formContent = {
    ALIADO: {
      titulo: "HAZ CRECER TU NEGOCIO JUNTO A NOSOTROS",
      texto: "Conviértete en aliado estratégico y conecta con empresas que buscan evolucionar. Juntos podemos generar impacto real en México.",
      formTitulo: "REGÍSTRATE COMO ALIADO",
      formTexto: "Únete a nuestra red de aliados estratégicos y abre nuevas oportunidades de negocio.",
      imagen: require("../recursos/consultoria/Icon-aliados.png"),
      fondo: require("../recursos/consultoria/Fondo-Aliados.png")
    },
    COLABORADOR: {
      titulo: "TRABAJAR CON RESPETO Y DIGNIDAD SÍ ES POSIBLE",
      texto: "En Empática conectamos personas con empresas que saben cuidar a su gente. Regístrate en nuestra cartera y da el siguiente paso hacia un empleo formal y con sentido.",
      formTitulo: "SÚMATE A NUESTRA CARTERA DE TALENTO.",
      formTexto: "Creamos un millón de relaciones sanas conectando a personas con empresas que valoran su talento. Si buscas estabilidad, prestaciones de ley y una cultura que te respete, aquí empieza tu evolución.",
      imagen: require("../recursos/consultoria/red.png"),
      fondo: require("../recursos/consultoria/Fondo-Colaboradores.png")
    },
    CLIENTE: {
      titulo: "EVOLUCIONA TU EMPRESA CON SOLUCIONES A LA MEDIDA",
      texto: "Ofrecemos consultoría especializada para que tu organización evolucione con propósito y sostenibilidad.",
      formTitulo: "SOLICITA MÁS INFORMACIÓN",
      formTexto: "Comparte tus datos y te contactaremos para diseñar soluciones que impulsen tu negocio.",
      imagen: require("../recursos/consultoria/Icon-Clientes.png"),
      fondo: require("../recursos/consultoria/Fondo-Clientes.png")
    }
  };


  return (
    <div style={{ fontFamily: 'Arial, sans-serif', margin: 0, padding: 0 }}>
      {/* ===== Portada ===== */}
      <div style={{
        color: '#fff',
        width: '100%',
        minHeight: '100vh', // 👈 evita que se corte el contenido en móviles
        backgroundImage: `url(${fondo})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{
          width: '100%',
          flex: 1,
          padding: '30px 5%',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Header */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 40,
            flexWrap: 'wrap',
            position: 'relative',
            zIndex: 10
          }}>
            {/* Logo */}
            <img
              src={require('../recursos/consultoria/Consulting-logo.png')}
              alt="Logo IVD"
              style={{ height: 40, marginBottom: 15 }}
            />

            {/* Menú */}
            {isMobile ? (
              <>
                <button onClick={() => setMenuOpen(!menuOpen)} style={{
                  background: 'none',
                  border: '2px solid white',
                  padding: '8px 12px',
                  borderRadius: 5,
                  color: '#fff',
                  fontSize: 18,
                  cursor: 'pointer'
                }}>
                  ☰
                </button>
                {menuOpen && (
                  <div style={{
                    position: 'absolute',
                    top: 60,
                    right: 0,
                    backgroundColor: '#001e3e',
                    padding: '20px 30px',
                    borderRadius: '10px 0 10px 10px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.4)'
                  }}>
                    {navItems.map((item, i) => (
                      <div key={i} style={{
                        marginBottom: 10,
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleMenuClick(item.id);
                          }}
                          style={{
                            color: '#fff',
                            textDecoration: 'none',
                            fontSize: 14,
                            cursor: 'pointer'
                          }}
                        >
                          {item.label}
                        </a>
                        {i !== navItems.length - 1 && (
                          <span style={{ margin: '0 8px', color: '#fff' }}>|</span>
                        )}
                      </div>
                    ))}
                    <a
                      href="https://wa.me/5214434847851?text=Hola%2C%20me%20interesa%20m%C3%A1s%20informaci%C3%B3n%20sobre%20sus%20vacantes"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'inline-block',
                        marginTop: 15,
                        backgroundColor: '#00b4ff',
                        padding: '8px 18px',
                        borderRadius: 20,
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: 13,
                        textDecoration: 'none',
                        letterSpacing: 1,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
                      }}
                    >
                      VACANTES
                    </a>
                  </div>
                )}
              </>
            ) : (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                fontSize: 14,
                flexWrap: 'wrap',
                justifyContent: 'center',
                marginTop: 10
              }}>
                {navItems.map((item, i) => (
                  <span key={i} style={{ display: 'flex', alignItems: 'center' }}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleMenuClick(item.id);
                      }}
                      style={{
                        color: '#fff',
                        textDecoration: 'none',
                        cursor: 'pointer'
                      }}
                    >
                      {item.label}
                    </a>
                    {i !== navItems.length - 1 && (
                      <span style={{ margin: '0 12px', color: '#fff' }}>|</span>
                    )}
                  </span>
                ))}
                <a
                  href="https://wa.me/5214434847851?text=Hola%2C%20me%20interesa%20m%C3%A1s%20informaci%C3%B3n%20sobre%20sus%20vacantes"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    marginLeft: 20,
                    backgroundColor: '#00b4ff',
                    padding: '8px 18px',
                    borderRadius: 20,
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: 13,
                    textDecoration: 'none',
                    letterSpacing: 1,
                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
                  }}
                >
                  VACANTES
                </a>
              </div>
            )}
          </div>

          {/* Contenido */}
          <div style={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            maxWidth: 650
          }}>
            <h1 style={{
              marginBottom: 25,
              fontFamily: 'Montserrat-Bold',
              fontSize: 'clamp(28px, 6vw, 50px)', // 👈 grande en desktop, legible en móviles
              lineHeight: 1.2
            }}>
              1 Millón de aliados evolucionando a México.
            </h1>
            <p style={{
              fontSize: 'clamp(18px, 4vw, 26px)', // 👈 no se achica demasiado
              marginBottom: 30,
              fontFamily: 'Montserrat-Regular',
              lineHeight: 1.4
            }}>
              En Empática Consulting alineamos voluntades, conectamos propósito con acción y
              facilitamos la evolución de personas, equipos y organizaciones
              que están reescribiendo la forma de hacer empresa en México.
            </p>
            <button
              onClick={() =>
                openModal({
                  from: "PORTADA", // 👈 indicador
                  titulo: "Más sobre Empática Consulting",
                  contenido: (
                    <>
                      <p>
                        En Empática Consulting, diseñamos y operamos un Sistema Directivo 360° que alinea estrategia, procesos, personas y números.
                        Implementamos hábitos semanales, KPIs con semáforo, Job Scorecards, procesos legales, playbooks comerciales y We360° (seguimiento y accountability).
                      </p>
                      <br />
                      <p>
                        <b>Diferenciadores clave:</b>
                        <br />- Enfoque integral 360° (Legal + Personas + Operación + Comercial + Finanzas + Marketing).
                        <br />- Metodologías probadas (Scaling Up, Adizes, Topgrading) aterrizadas al contexto del Bajío y Michoacán.
                        <br />- Entregables accionables (no PDFs decorativos): JSC, DDP, tableros, reglamentos, campañas, playbooks.
                        <br />- Ritmo de juntas y semáforos: disciplina de ejecución semana a semana.
                        <br />- IA y automatización a tu medida (asistentes especializados, formularios, dashboards).
                        <br />- Cultura firme pero cálida: “ni mentiritas ni milagritos”, foco en evidencia y ROI operativo.
                      </p>
                    </>
                  )
                })
              }
              style={{
                backgroundColor: "#3d6de1",
                border: "none",
                padding: "12px 20px",
                borderRadius: 20,
                fontSize: 18,
                color: "#fff",
                cursor: "pointer",
                width: 190,
                alignSelf: "flex-start"
              }}
            >
              Más información
            </button>

          </div>
        </div>
      </div>


      {/* ===== Servicios ===== */}
      <div style={{
        backgroundColor: '#f5f7fa',
        padding: '60px 20px',
        textAlign: 'center'
      }}>
        <h2 style={{
          fontSize: 36,
          color: '#22354c',
          letterSpacing: 1,
          marginBottom: 40,
          fontFamily: 'Montserrat-Regular'
        }}>
          SERVICIOS
        </h2>

        <Slider
          dots
          infinite={false}
          speed={500}
          slidesToShow={4}  
          slidesToScroll={4} 
          responsive={[
            {
              breakpoint: 1200,
              settings: { slidesToShow: 3, slidesToScroll: 3 }
            },
            {
              breakpoint: 900,
              settings: { slidesToShow: 2, slidesToScroll: 2 }
            },
            {
              breakpoint: 600,
              settings: { slidesToShow: 1, slidesToScroll: 1 }
            }
          ]}
        >
          {servicios.map((serv, idx) => (
            <div key={idx}>
              {/* 👉 aquí va tu card exactamente igual como estaba */}
              <div
                onClick={() => openModal(serv.modal)}
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: 10,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  paddingBottom: 20,
                  cursor: "pointer",
                  margin: "0 auto",     
                  maxWidth: 300,
                  minHeight: 280,
                }}
              >
                {/* Franja azul */}
                <div style={{
                  height: 8,
                  backgroundColor: '#1f4aa8',
                  width: '100%',
                }}></div>

                {/* Imagen */}
                <img
                  src={serv.img}
                  alt={serv.titulo}
                  style={{
                    width: '100%',
                    height: 160,
                    objectFit: 'cover',
                    marginBottom: 15
                  }}
                />

                {/* Título */}
                <p style={{
                  fontSize: 22,
                  color: '#1f4aa8',
                  fontFamily: 'Montserrat-Regular',
                  textTransform: 'uppercase',
                  margin: 10,
                  textAlign: 'center',
                  lineHeight: 1.2,
                  letterSpacing: '-0.5px',
                }}>
                  {serv.titulo}
                </p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      {modalOpen && modalData && (
        <div
          onClick={closeModal}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: 10,
              width: "90%",
              maxWidth: "600px",
              padding: "20px 30px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
              position: "relative",

              ...(modalData.from === "PORTADA" && {
                maxHeight: "80vh",
                overflowY: "auto"
              })
            }}
          >
            <h2
              style={{
                backgroundColor: "#007bff",
                color: "#fff",
                padding: "12px",
                borderRadius: "8px 8px 0 0",
                margin: "-20px -30px 20px -30px",
                fontFamily: "Montserrat-Bold",
                textAlign: "center",
                fontSize: "20px"
              }}
            >
              {modalData.titulo}
            </h2>

            <div style={{ fontSize: 20, color: "#22354c", lineHeight: 1.5 }}>
              {modalData.contenido}
            </div>

            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: 10,
                right: 15,
                background: "none",
                border: "none",
                fontSize: 22,
                cursor: "pointer",
                color: "#333"
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* ===== Cultura y Filosofía ===== */}
      <div
        ref={culturaRef}
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "center",
          alignItems: "center",
          gap: isMobile ? "8px" : 160,
          padding: isMobile ? "20px 5%" : "80px 10%",
          backgroundColor: "#ffffff",
        }}
      >
        {/* Columna de imagen */}
        <div
          style={{
            position: "relative",
            flex: isMobile ? "0 1 auto" : "1 1 500px",
            maxWidth: isMobile ? "100%" : 600,
            width: isMobile ? "100%" : "auto",
            marginTop: 0,
            order: isMobile ? 1 : 0,
          }}
        >
          {isMobile ? (
            <img
              src={require("../recursos/consultoria/Img-Movil-Filosofia.png")}
              alt="equipo mobile"
              style={{
                width: "100%",
                borderRadius: 12,
                objectFit: "cover",
                maxHeight: "250px",
              }}
            />
          ) : (
            <>
              {/* Fondo equipo (desktop) */}
              <img
                src={imgFondoEquipo}
                alt="equipo"
                style={{
                  width: "100%",
                  borderRadius: 12,
                  objectFit: "cover",
                }}
              />

              {/* Bloque azul detrás de la empresaria */}
              <div
                style={{
                  position: "absolute",
                  right: "-40px",
                  bottom: "350px",
                  width: 180,
                  height: "35%",
                  backgroundColor: "#1f357a",
                  zIndex: 1,
                  borderRadius: 8,
                }}
              ></div>

              {/* Empresaria */}
              <img
                src={imgPersona}
                alt="persona"
                style={{
                  position: "absolute",
                  right: "-180px",
                  bottom: 0,
                  width: 360,
                  zIndex: 2,
                  borderRadius: 8,
                }}
              />
            </>
          )}
        </div>

        {/* Columna de texto con carrusel */}
        <div
          style={{
            flex: isMobile ? "0 1 auto" : "1 1 400px",
            maxWidth: isMobile ? "100%" : 500,
            marginLeft: isMobile ? "0px" : "40px",
            marginTop: isMobile ? "35px" : 0,
            marginBottom: isMobile ? "15px" : 0,
            textAlign: isMobile ? "center" : "left",
            order: isMobile ? 2 : 0,
            height: "auto",
          }}
        >
          <Slider
            {...{
              dots: true,
              infinite: true,
              speed: 500,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 5000,
              adaptiveHeight: true,
              appendDots: dots => (
                <div style={{ marginTop: "30px" }}>
                  <ul style={{ margin: "0px" }}>{dots}</ul>
                </div>
              ),
              customPaging: () => (
                <div
                  style={{
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    backgroundColor: "#bbb",
                  }}
                ></div>
              ),
            }}
          >
            <div style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: isMobile ? "center" : "flex-start",
              paddingBottom: "10px", 
            }}>
              <h3 style={{ color: "#1f4aa8", fontSize: isMobile ? "22px" : 38, fontFamily: "Montserrat-Bold", lineHeight: "1", marginBottom: "25px" }}>
                SOMOS LEALES A NUESTRA CULTURA Y FILOSOFÍA
              </h3>
              <p style={{ fontSize: isMobile ? "14px" : 20, color: "#333", fontFamily: "Montserrat-Regular", marginBottom: "25px" }}>
                Somos fieles a nuestra esencia, pero nunca estáticos. Evolucionamos con el tiempo sin perder lo que nos define. Nuestra filosofía guía nuestras acciones,
                decisiones y la forma en que impactamos positivamente a cada cliente. Evolucionamos a México un
                empresario a la vez.
              </p>
            </div>
            <div style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: isMobile ? "center" : "flex-start",
              paddingBottom: "10px", 
            }}>
              <h3 style={{ color: "#1f4aa8", fontSize: isMobile ? "22px" : 38, fontFamily: "Montserrat-Bold", lineHeight: "1", marginBottom: "25px" }}>
                ¿QUIÉNES SOMOS?
              </h3>
              <p style={{ fontSize: isMobile ? "14px" : 20, color: "#333", fontFamily: "Montserrat-Regular", marginBottom: "25px" }}>
                En Empática Consulting creemos que las empresas son seres vivos. Algunas crecen rápido, otras se estancan;
                pero todas necesitan evolucionar.
                <p>Nuestro rol no es dictarles qué hacer, sino escucharlas, acompañarlas y darles estructura para que encuentren su rumbo.</p>
                Trabajamos con metodologías internacionales de Ingeniería Inversa adaptadas a la realidad mexicana.
                <p>Y las operamos con herramientas vivas: Tableros de Control, sistemas de evaluación de desempeño laboral y cultural,
                sistemas de gestión y cultura, sistemas de posicionamiento y gestión empresarial, tableros de control físicos y digitales.</p>
              </p>
            </div>
            <div style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: isMobile ? "center" : "flex-start",
              paddingBottom: "10px", 
            }}>
              <h3 style={{ color: "#1f4aa8", fontSize: isMobile ? "22px" : 38, fontFamily: "Montserrat-Bold", marginBottom: "25px" }}>
                ¿QUÉ HACEMOS?
              </h3>
              <p style={{ fontSize: isMobile ? "14px" : 20, color: "#333", fontFamily: "Montserrat-Regular", marginBottom: "25px" }}>
                Construimos tu sistema de dirección y lo alineamos a las áreas claves de tu organización como pueden ser: Legal, Talento, Operaciones, Comercial, Finanzas, Cmercial, Marketing, etc.
                Entregamos una cultura clara, sólida con mediante roles que la cuidan y la potencializan.
              </p>
            </div>
            <div style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: isMobile ? "center" : "flex-start",
              paddingBottom: "10px", 
            }}>
              <h3 style={{ color: "#1f4aa8", fontSize: isMobile ? "22px" : 38, fontFamily: "Montserrat-Bold", marginBottom: "25px" }}>
                ¿CÓMO LO HACEMOS?
              </h3>
              <p
                style={{
                  fontSize: isMobile ? "14px" : 20,
                  color: "#333",
                  fontFamily: "Montserrat-Regular",
                  marginBottom: "25px",
                }}
              >
                A través de un modelo de 4 fases:
              </p>

              <div
                style={{
                  marginLeft: "25px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px", 
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "14px" : 20,
                    color: "#333",
                    fontFamily: "Montserrat-Regular",
                    textAlign: "justify",
                    lineHeight: 1.5,
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                      fontFamily: "Montserrat-Bold",
                    }}
                  >
                    • Abrazamos tu empresa:
                  </span>{" "}
                  Diánosticos de realidad de tu empresa, con entrevistas, formularios, revisión documental, 
                  mapeo de procesos y de riesgos, así como planeaciones anulaes y trimestrales con propósito. 
                </p>

                <p
                  style={{
                    fontSize: isMobile ? "14px" : 20,
                    color: "#333",
                    fontFamily: "Montserrat-Regular",
                    textAlign: "justify",
                    lineHeight: 1.5,
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                      fontFamily: "Montserrat-Bold",
                    }}
                  >
                    • Aceleramos tu evolución:
                  </span>{" "}
                  Integrando y alineando a expertos que nos apoyen a consolidad tu sistema operativo. 
                </p>

                <p
                  style={{
                    fontSize: isMobile ? "14px" : 20,
                    color: "#333",
                    fontFamily: "Montserrat-Regular",
                    textAlign: "justify",
                    lineHeight: 1.5,
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                      fontFamily: "Montserrat-Bold",
                    }}
                  >
                    • Repetibilidad y escalamiento:
                  </span>{" "}
                  comunicación asertiva que permita el cascadeo de la cultura, tablero de evaluación de desempeño y 
                  plataformas tecnologicas que faciliten la gestión de todos los recuersos de la empresa.
                </p>

                <p
                  style={{
                    fontSize: isMobile ? "14px" : 20,
                    color: "#333",
                    fontFamily: "Montserrat-Regular",
                    textAlign: "justify",
                    lineHeight: 1.5,
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                      fontFamily: "Montserrat-Bold",
                    }}
                  >
                    • Encordamiento:
                  </span>{" "}
                  Ecosistema compartido, recursos colectivos, negociaciones conjuntas, acompañamiento y mejora continua,
                   auditorias de cumplimiento, couching de líderez y ajustes trimestrales. 
                </p>
              </div>
            </div>
          </Slider>

          {/* Botón debajo del carrusel */}
          <div style={{
            textAlign: isMobile ? "center" : "left",
            marginTop: isMobile ? "30px" : "40px",
          }}>
            <button
             onClick={() => window.open("https://wa.me/524431747231?text=Hola%2C%20vi%20la%20p%C3%A1gina%20de%20Emp%C3%A1tica%20Consulting%20y%20me%20interesa%20m%C3%A1s%20informaci%C3%B3n%20su%20diagn%C3%B3stico%20306%C2%B0", "_blank")}
              style={{
                backgroundColor: "#3d6de1",
                border: "none",
                padding: "12px 25px",
                borderRadius: 25,
                fontSize: 16,
                fontFamily: "Montserrat-Regular",
                color: "#fff",
                cursor: "pointer",
                marginTop: "20ox",

              }}
            >
              Agenda un diagnóstico 360°
            </button>
          </div>
        </div>
      </div>

      {/* ===== Clientes / Alianzas ===== */}
      <div
        ref={alianzasRef}
        style={{
          background: "linear-gradient(to bottom, #f5f5f5, #eaeaea)",
          padding: "40px 5%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Slider
          autoplay
          autoplaySpeed={0}       
          infinite
          speed={4000}           
          cssEase="linear"        
          slidesToShow={isMobile ? 2 : 6}
          slidesToScroll={1}
          arrows={false}
          dots={false}
          pauseOnHover={false}    // sigue corriendo aunque pases el mouse
          style={{ width: "100%", maxWidth: isMobile ? "400px" : "1400px" }}
        >

          <div>
            <img
              src={require("../recursos/consultoria/GR.png")}
              alt="Grupo Rangel"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/METROLOGICO.png")}
              alt="Centro Metrológico"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/ES.png")}
              alt="Empática Soluciones"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/IVD.png")}
              alt="IVD"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/LOP.png")}
              alt="Empática Soluciones"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/Objeto-inteligente-vectorial-1.png")}
              alt="V1"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/Objeto-inteligente-vectorial-3.png")}
              alt="V1"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/Greenthink.png")}
              alt="Centro Metrológico"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/Objeto-inteligente-vectorial-5.png")}
              alt="V5"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/Objeto-inteligente-vectorial-6.png")}
              alt="V6"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/POLLO-CHONCHO.png")}
              alt="Choncho"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/BLANKITA.png")}
              alt="Blanquita"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/Objeto-inteligente-vectorial-2.png")}
              alt="Blanquita"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/Objeto-inteligente-vectorial-7.png")}
              alt="V7"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/Objeto-inteligente-vectorial-4.png")}
              alt="V4"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
          <div>
            <img
              src={require("../recursos/consultoria/Objeto-inteligente-vectorial.png")}
              alt="V"
              style={{ maxHeight: 70, margin: "0 auto", objectFit: "contain" }}
            />
          </div>
        </Slider>
      </div>

      {/* ===== ALINEAMOS ===== */}
      <div style={{
        backgroundImage: `url(${require('../recursos/consultoria/Saludo.png')})`, // Cambia por tu imagen real
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '180px 5%',
        textAlign: 'center',
        color: '#fff',
        position: 'relative'
      }}>
        {/* Capa oscura encima de la imagen */}
        <div style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0
        }}></div>

        {/* Texto */}
        <div style={{
          fontFamily: 'Montserrat-Regular',
          position: 'relative',
          zIndex: 2,
          fontSize: 38,
          letterSpacing: 2,
          fontWeight: 400
        }}>
          ALINEAMOS NUESTRA INTENCIÓN <br />
          CON NUESTRA REALIDAD VIVIDA
        </div>
      </div>

      {/* ===== Sección We360 ===== */}
      <div
        ref={we360Ref}
        style={{
          backgroundImage: `url(${require("../recursos/consultoria/Fondo-WE.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh", // se expande si hay más contenido
          width: "100%",
          color: "#fff",
          position: "relative",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        {/* Capa oscura */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1,
          }}
        ></div>

        {/* Contenido */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            maxWidth: isMobile ? "90%" : "800px", // 👈 más angosto en móvil
            textAlign: "left",
            paddingTop: isMobile ? "380px" : "250px", // 👈 menos margen arriba en móvil
            paddingLeft: "8%",
          }}
        >
          {/* Logo We360 */}
          <img
            src={require("../recursos/consultoria/Logo-WE.png")}
            alt="We360"
            style={{
              height: isMobile ? 90 : 150, // 👈 más chico en móvil
              marginBottom: 20,
            }}
          />

          {/* Título */}
          <h2
            style={{
              fontSize: isMobile ? 32 : 58, // 👈 ajusta en móvil
              fontFamily: "Branding-Medium",
              lineHeight: 1,
              marginBottom: 20,
            }}
          >
            Impulsa el bienestar <br /> en tu empresa
          </h2>

          {/* Descripción */}
          <p
            style={{
              fontSize: isMobile ? 18 : 30, // 👈 más chico en móvil
              fontFamily: "Branding-Medium",
              lineHeight: 1,
              marginBottom: 30,
            }}
          >
            Programas de bienestar corporativo que aumentan la productividad,
            retienen talento y mejoran el clima laboral.
          </p>

          {/* Botón */}
          <button
            style={{
              border: "2px solid #93b4a8",
              background: "transparent",
              padding: isMobile ? "8px 20px" : "10px 30px", // 👈 más pequeño en móvil
              borderRadius: 25,
              fontSize: isMobile ? 16 : 22, // 👈 reduce tamaño en móvil
              fontFamily: "Branding-Medium",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            Más información
          </button>
        </div>
      </div>

      {/* ===== Casos de Éxito ===== */}
      <div
        style={{
          backgroundColor: "#1f357a",
          color: "#fff",
          padding: "80px 8%",
          textAlign: "left",
        }}
      >
        {/* Título */}
        <h2
          style={{
            fontSize: 40,
            letterSpacing: 6,
            textAlign: "center",
            marginBottom: 30,
            fontFamily: "Montserrat-Regular",
            lineHeight: "1.2",
          }}
        >
          CASO DE ÉXITO / KICK OFF
        </h2>

        {/* Contenido principal */}
        <div
          style={{
            display: isMobile ? "flex" : "grid",
            flexDirection: isMobile ? "column" : "initial",
            gridTemplateColumns: isMobile ? "none" : "1fr 1fr 1fr",
            gap: "40px",
            alignItems: "flex-start",
          }}
        >
          {/* Columna izquierda: Texto */}
          <div
            style={{
              order: isMobile ? 1 : 0, // 👈 texto después del título
            }}
          >
            <h3
              style={{
                fontSize: isMobile ? 26 : 35,
                marginBottom: 20,
                fontFamily: "Montserrat-Regular",
                lineHeight: 1.3,
                textAlign: isMobile ? "center" : "left",
              }}
            >
              Haz que tu equipo <br /> arranque con propósito <br /> y energía
            </h3>
            <p
              style={{
                fontSize: isMobile ? 16 : 20,
                lineHeight: 1.6,
                marginBottom: 30,
                fontFamily: "Montserrat-Regular",
                textAlign: isMobile ? "center" : "left",
              }}
            >
              Un Kick Off no es solo una reunión de inicio: es el momento en que cada
              colaborador conecta con la visión, los valores y los objetivos de la
              empresa. Es más que sembrar motivación, es inspirar, comprometer y
              entusiasmar, para afrontar nuevos retos con claridad y unidad.
            </p>
            <div style={{ textAlign: isMobile ? "center" : "left" }}>
              <button
                style={{
                  backgroundColor: "#3d6de1",
                  border: "none",
                  padding: "12px 30px",
                  borderRadius: 25,
                  fontSize: 15,
                  fontFamily: "Montserrat-Regular",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                MÁS INFORMACIÓN
              </button>
            </div>
          </div>

          {/* Columna central: Imagen principal */}
          <div
            style={{
              order: isMobile ? 3 : 0, // 👈 imagen después del texto en móvil
            }}
          >
            <img
              src={require("../recursos/consultoria/Foto-KO-1.png")}
              alt="Kick Off Evento"
              style={{
                width: "100%",
                borderRadius: 8,
                marginTop: isMobile ? 20 : 0,
              }}
            />
          </div>

          {/* Columna derecha: Logo + Foto */}
          <div
            style={{
              textAlign: "center",
              order: isMobile ? 2 : 0, // 👈 logo + foto hasta el final en móvil
            }}
          >
            <img
              src={require("../recursos/consultoria/LOP-Logo.png")}
              alt="Logo Empresa"
              style={{
                height: isMobile ? 70 : 90,
                marginBottom: 25,
                marginLeft: isMobile ? 0 : 200,
              }}
            />
            <img
              src={require("../recursos/consultoria/Foto-KO-2.png")}
              alt="Equipo Kick Off"
              style={{ width: "100%", borderRadius: 8 }}
            />
          </div>
        </div>
      </div>

      {/* ===== Formularios ===== */}
      {!isMobile && (
        <div
          style={{
            background: "linear-gradient(90deg, #0046b3, #005eff)",
            padding: "80px 5%",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <h2
            style={{
              fontSize: 38,
              letterSpacing: 8,
              fontFamily: "Montserrat-Regular",
              marginBottom: 50,
            }}
          >
            FORMULARIOS
          </h2>

          {/* Botones */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "30px",
              flexWrap: "wrap",
            }}
          >
            {["ALIADO", "COLABORADOR", "CLIENTE"].map((btn) => (
              <button
                key={btn}
                onClick={() => setSelectedForm(btn)}
                style={{
                  width: 300,
                  padding: "14px 0",
                  borderRadius: 30,
                  fontSize: 18,
                  fontFamily:
                    selectedForm === btn
                      ? "Montserrat-Bold"
                      : "Montserrat-Regular",
                  border: "2px solid #fff",
                  background:
                    selectedForm === btn
                      ? "#d0d8f0"
                      : "rgba(255,255,255,0.2)",
                  color: selectedForm === btn ? "#0e1f3e" : "#fff",
                  cursor: "pointer",
                  textAlign: "center",
                }}
              >
                {btn}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* ===== Footer Final (dinámico) ===== */}
      <div
        ref={footerRef}
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row", // fila en desktop, columna en móvil
          minHeight: "100vh",
          width: "100%",
        }}
      >
        {/* Columna izquierda */}
        <div
          style={{
            flex: 1,
            backgroundColor: "#fff",
            padding: isMobile ? "40px 8%" : "80px 8%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            order: isMobile ? 1 : 0, // 👉 en móvil va primero
          }}
        >
          <img
            src={formContent[selectedForm].imagen}
            alt="Icono"
            style={{ height: 180, marginBottom: 50 }}
          />
          <h2
            style={{
              color: "#0e2b56",
              fontSize: isMobile ? 28 : 40,
              fontFamily: "Montserrat-Bold",
              marginBottom: 25,
              lineHeight: 1.3,
              maxWidth: 600,
            }}
          >
            {formContent[selectedForm].titulo}
          </h2>
          <p
            style={{
              fontSize: isMobile ? 16 : 20,
              color: "#333",
              fontFamily: "Montserrat-Regular",
              lineHeight: 1.6,
              maxWidth: 600,
            }}
          >
            {formContent[selectedForm].texto}
          </p>
        </div>

        {/* Botones de formularios (en medio solo en móvil) */}
        {isMobile && (
          <div
            style={{
              background: "linear-gradient(90deg, #0046b3, #005eff)",
              padding: "40px 5%",
              textAlign: "center",
              color: "#fff",
              order: 2,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                letterSpacing: 6,
                fontFamily: "Montserrat-Regular",
                marginBottom: 30,
              }}
            >
              FORMULARIOS
            </h2>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                flexWrap: "wrap",
              }}
            >
              {["ALIADO", "COLABORADOR", "CLIENTE"].map((btn) => (
                <button
                  key={btn}
                  onClick={() => setSelectedForm(btn)}
                  style={{
                    width: 250,
                    padding: "12px 0",
                    borderRadius: 30,
                    fontSize: 16,
                    fontFamily:
                      selectedForm === btn
                        ? "Montserrat-Bold"
                        : "Montserrat-Regular",
                    border: "2px solid #fff",
                    background:
                      selectedForm === btn
                        ? "#d0d8f0"
                        : "rgba(255,255,255,0.2)",
                    color: selectedForm === btn ? "#0e1f3e" : "#fff",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                >
                  {btn}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Columna derecha (Formulario) */}
        <div
          style={{
            flex: 1,
            backgroundImage: `url(${formContent[selectedForm].fondo})`, // 👈 dinámico
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: isMobile ? "40px 20px" : "60px",
            order: isMobile ? 3 : 1,
          }}
        >
          <div
            style={{
              position: "relative",
              zIndex: 2,
              backgroundColor: "rgba(20, 60, 150, 0.6)",
              padding: isMobile ? "30px" : "40px",
              borderRadius: 12,
              width: "100%",
              maxWidth: 420,
              color: "#fff",
            }}
          >
            <h3
              style={{
                fontSize: 24,
                marginBottom: 15,
                fontFamily: "Montserrat-Bold",
                textAlign: "center",
              }}
            >
              {formContent[selectedForm].formTitulo}
            </h3>
            <p
              style={{
                fontSize: 16,
                lineHeight: 1.4,
                marginBottom: 25,
                fontFamily: "Montserrat-Regular",
                textAlign: "center",
              }}
            >
              {formContent[selectedForm].formTexto}
            </p>

            <input type="text" placeholder="Nombre" style={inputStyle} />
            <input type="email" placeholder="Email" style={inputStyle} />
            <input
              type="tel"
              placeholder="Teléfono"
              style={{ ...inputStyle, marginBottom: "25px" }}
            />
            {selectedForm === "CLIENTE" && (
              <textarea
                placeholder="Nombre de la empresa"
                style={{
                  ...inputStyle,
                  height: 100,
                  resize: "none",
                  marginBottom: "25px",
                }}
              />
            )}

            {selectedForm === "ALIADO" && (
              <button
                style={{
                  backgroundColor: "#fff",
                  color: "#0e2b56",
                  display: "block",
                  margin: "0 auto 20px",
                  padding: "12px 25px",
                  borderRadius: 25,
                  fontSize: 16,
                  fontFamily: "Montserrat-Regular",
                  cursor: "pointer",
                }}
              >
                Subir mi CV
              </button>
            )}


            <button
              style={{
                width: "100%",
                backgroundColor: "#00ffc8",
                border: "none",
                padding: "14px",
                borderRadius: 6,
                fontSize: 18,
                fontFamily: "Montserrat-Regular",
                color: "#0e2b56",
                cursor: "pointer",
              }}
            >
              ENVIAR
            </button>
          </div>
        </div>
      </div>

    </div>

  );

};

export default PortadaEmpatica;
